/** @format */

import React from 'react';
import tw from 'twin.macro';
import { css } from 'styled-components/macro'; //eslint-disable-line
import { Container } from 'components/misc/Layouts.js';
import { SectionHeading as Heading, Subheading } from 'components/misc/Headings.js';
import { Heart, Star } from 'components/testimonialpng';
const Testimonials = tw.div`flex flex-col lg:flex-row items-center lg:items-stretch`;
const TestimonialContainer = tw.div`mt-16 lg:w-1/3`;
const Testimonial = tw.div`px-4 text-center max-w-xs mx-auto flex flex-col items-center`;
const Image = tw.img`w-20 h-20 rounded-full`;
const Quote = tw.blockquote`mt-5 text-gray-600 font-medium leading-loose`;
const CustomerName = tw.p`mt-5 text-gray-900 font-semibold  text-sm tracking-wide`;
const Subheadingnew = tw(Subheading)`
text-gray-600 font-normal text-center sm:w-6/12 mx-auto mt-6
`;

const Test = ({
	subheading = 'With a lots of uniqure block you can easily build a page without coding. Build your next website fast.',
	heading = 'Customers are Loving it',
	testimonials = [
		{
			imageSrc:
				'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=3.25&w=512&h=512&q=80',
			quote: 'You made it so simple> My life so much better and easier to work with than my old life.',
			customerName: 'Alan Farmer',
		},
		{
			imageSrc:
				'https://images.unsplash.com/photo-1531427186611-ecfd6d936c79?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2.25&w=512&h=512&q=80',
			quote: "Simply the best. Better than all the rest. I'd recommend this product to beginners and advanced users",
			customerName: 'Christina Olson',
		},
		{
			imageSrc:
				'https://images.unsplash.com/photo-1580852300654-03c803a14e24?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=4.25&w=512&h=512&q=80',
			quote: 'Must have service for all, who want to be successful credit planning in the professional and personal life',
			customerName: 'Lewis Ingram',
		},
	],
}) => {
	return (
		<Container className="testimonials">
			<Heading>{heading}</Heading>
			<Subheadingnew>{subheading}</Subheadingnew>
			<Testimonials>
				{testimonials.map((testimonial, index) => (
					<TestimonialContainer key={index}>
						<Testimonial>
							<Image src={testimonial.imageSrc} />
							<Quote>"{testimonial.quote}"</Quote>
							<CustomerName> {testimonial.customerName}</CustomerName>
						</Testimonial>
					</TestimonialContainer>
				))}
			</Testimonials>

			<Heart />
			<Star />
		</Container>
	);
};
export default Test;
